import { render, staticRenderFns } from "./InputMultifile.vue?vue&type=template&id=349505c5&"
import script from "./InputMultifile.vue?vue&type=script&lang=js&"
export * from "./InputMultifile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports